import { Box, Button, DataTable } from 'grommet';
import { Cell } from 'modules/admin/Common';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { dispatchAction } from 'rxbeach';
import { connect } from 'rxbeach/react';
import { BaseAsset, Meta } from 'types';
import { formatDate } from 'utils/dateUtils';
import { parseIntSafely } from 'utils/numberUtils';
import { admin$, adminSetActive } from './admin$';


interface AssetAdminProps {
  data: (Meta & BaseAsset)[];
  byId: Record<string, Meta>
  columns: any[],
  Editor: any
  active: any;
}

const CommonAssetAdmin = ({
  data,
  byId,
  columns,
  Editor,
  active,
}: AssetAdminProps) => {
  const [sort, setSort] = useState<{ property: string, direction: 'asc' | 'desc' }>({
    property: 'createdAt',
    direction: 'desc',
  });
  const param = useParams<{ id: string, tab: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    // TODO byId is not the same as param.id which is shortid
    dispatchAction(adminSetActive(byId?.[param.id!]));
  }, [!!byId]);

  const allColumns = [
    ...columns,
    {
      header: 'Siste endret',
      property: 'modifiedAt',
      render: (e: any) => (
        <Cell>
          {formatDate(e.modifiedAt)}
        </Cell>)
    },
    // TODO email/name instead of id
    // { header: 'Opprett av', property: 'createdBy' },
    {
      header: 'Opprett',
      property: 'createdAt',
      render: (e: any) => (
        <Cell>
          {formatDate(e.createdAt)}
        </Cell>)
    },
    // { header: 'Siste endret av', property: 'modifiedBy' },
    {
      header: '',
      verticalAlign: 'middle',
      align: 'center',
      property: '',
      render: (e: any) => (
        <Cell>
          <Button
            size="small"
            secondary
            label="Rediger"
            onClick={() => {
              navigate(`/admin/${param.tab}/${e.shortid}`)
              dispatchAction(adminSetActive(e))
            }}
          />
        </Cell>
      )
    }
  ];

  return (
    <>
      {!active && (
        <Box direction="row" style={{ minHeight: '40px', height: "40px" }}>
          <Button
            size="small"
            secondary
            label="Ny"
            onClick={() => {
              const shortid = Math.random().toString(36).substring(7)
              dispatchAction(adminSetActive({ shortid }))
              navigate(`/admin/${param.tab}/${shortid}`)
            }}
          />
        </Box>
      )}
      <Box gridArea="main" margin="small" style={{ overflow: 'auto' }}>
        {!active && (
          <DataTable
            columns={allColumns}
            data={data.map(e => ({ ...e, createdAt: formatDate(e.createdAt), modifiedAt: formatDate(e.modifiedAt), order: parseIntSafely(e.order) }))}
            step={20}
            background={{ header: { opacity: 'strong' } }}
            border={{ body: 'bottom' }}
            sort={sort}
            onSort={setSort}
            key="id"
            onClickRow={(event) => { }}
            paginate
          />
        )}
        {active && (
          <Editor
            asset={active}
            onDelete={() => {
              dispatchAction(adminSetActive(null))
            }}
          />
        )}
      </Box>
    </>
  );
};

export default connect(CommonAssetAdmin, admin$)
